import "./Navbar.css";
import React, { useState, useEffect, useMemo } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { collection, query, where, onSnapshot, limit } from "firebase/firestore";
import { db } from "../firebaseConfig";

/** Route sabitleri – Main.js ile aynı olmalı */

const PATHS = {
  dolum: "/mazot-takip/dolum",
  duzelt: "/mazot-takip/dolum-duzelt",
  ikmal: "/mazot-takip/ikmal",
  tankDuzelt: "/mazot-takip/tank-duzeltme",
  raporlar: "/mazot-takip/raporlar",
  hareketler: "/mazot-takip/hareketler",
  mazotListesi: "/mazot-takip/mazot-listesi", // ✅ EKLENDİ
  mailScheduler: "/mazot-takip/mail-scheduler",
  excelYukle: "/mazot-takip/excel-yukle",
  secim: "/secilen-proje",
};


const extractMazotMap = (obj = {}) => {
  if (!obj || typeof obj !== "object") return null;
  return (
    obj["mazot-takip"] ||
    obj.mazot_takip ||
    obj.mazottakip ||
    obj.mazotTakip ||
    null
  );
};

export default function Navbar() {
  const { user, userPermissions, userDoc, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Mazot map’i: önce context’ten, yoksa users by email
  const [perms, setPerms] = useState(null);

  useEffect(() => {
    const fromCtx =
      extractMazotMap(userPermissions || {}) || extractMazotMap(userDoc || {});
    if (fromCtx) {
      setPerms(fromCtx);
      return;
    }
    if (!user?.email) {
      setPerms(null);
      return;
    }
    const qRef = query(
      collection(db, "users"),
      where("email", "==", user.email),
      limit(1)
    );
    const unsub = onSnapshot(
      qRef,
      (snap) => {
        let found = null;
        snap.forEach((d) => {
          const data = d.data() || {};
          const m = extractMazotMap(data);
          if (m) found = m;
        });
        setPerms(found);
      },
      (err) => {
        console.error("⚠️ users dinleme hatası:", err);
        setPerms(null);
      }
    );
    return () => unsub();
  }, [user, userPermissions, userDoc]);

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".navbar")) setMenuOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const canCreator = !!perms?.olusturucu;
  const canInput = !!(perms?.giren || perms?.giren_onaylayan || perms?.olusturucu);
  const canApprove = !!(perms?.giren_onaylayan || perms?.olusturucu);
  const canView = !!(perms?.izleyen || canInput || canApprove);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (e) {
      console.error("Çıkış hatası:", e);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Mazot &amp; Tank Takip</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`}>
            {/* Sadece mazot map’ine göre görünürlük */}
            {canInput && <NavLink className="navbar-link" to={PATHS.dolum}>Dolum Ekle</NavLink>}
            {canInput && <NavLink className="navbar-link" to={PATHS.excelYukle}>Excel Yükle</NavLink>}
            {canInput && <NavLink className="navbar-link" to={PATHS.duzelt}>Düzelt / Sil</NavLink>}

            {canApprove && (
              <>
                <NavLink className="navbar-link" to={PATHS.ikmal}>Tank İkmal</NavLink>
                <NavLink className="navbar-link" to={PATHS.tankDuzelt}>Tank Sıfırlama</NavLink>
              </>
            )}

            {canView && <NavLink className="navbar-link" to={PATHS.raporlar}>Raporlar</NavLink>}
            {canView && <NavLink className="navbar-link" to={PATHS.hareketler}>Hareketler</NavLink>}
            {canCreator && <NavLink className="navbar-link" to={PATHS.mailScheduler}>Mail Programlama</NavLink>}
{canView && <NavLink className="navbar-link" to={PATHS.mazotListesi}>Mazot Listesi</NavLink>} {/* ✅ */}

            <NavLink className="navbar-link" to={PATHS.secim}>🔁 Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
}
